export default "__VITE_ASSET__qZbO3dQU__"